export default __webpack_public_path__ + "static/20-03b9efd2b0d25d8a729a08fd69946bd9.png";